import api from "@/lib/api";

export async function transferirAtendente(id, novoAtendente) {
  const { data } = await api.post(
    "/secretaria-digital/monitoring/transferir-atendente",
    {
      id,
      novoAtendente,
    },
  );
  return data;
}
